import React, { useState, useEffect } from 'react';
import { FaWhatsapp, FaChevronUp } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';
import './FloatingButtons.css';

export default function FloatingButtons() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 300);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <>
      {/* WhatsApp — bottom left */}
      <motion.a
        href="https://wa.me/18005551234"
        target="_blank"
        rel="noopener noreferrer"
        className="fab fab--whatsapp"
        aria-label="Chat on WhatsApp"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1.2, type: 'spring', stiffness: 260, damping: 20 }}
        whileHover={{ scale: 1.12 }}
        whileTap={{ scale: 0.95 }}
      >
        <FaWhatsapp />
        <span className="fab-tooltip">Chat with us</span>
      </motion.a>

      {/* Back to top — bottom right */}
      <AnimatePresence>
        {showTop && (
          <motion.button
            className="fab fab--top"
            onClick={scrollToTop}
            aria-label="Back to top"
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0, opacity: 0 }}
            transition={{ type: 'spring', stiffness: 260, damping: 20 }}
            whileHover={{ scale: 1.12 }}
            whileTap={{ scale: 0.95 }}
          >
            <FaChevronUp />
            <span className="fab-tooltip fab-tooltip--left">Back to top</span>
          </motion.button>
        )}
      </AnimatePresence>
    </>
  );
}
